var moduleMap = {
	"./Navigation": function() {
		return Promise.all([__webpack_require__.e(4223), __webpack_require__.e(4948), __webpack_require__.e(4920), __webpack_require__.e(8803), __webpack_require__.e(4305), __webpack_require__.e(2846), __webpack_require__.e(9926)]).then(function() { return function() { return (__webpack_require__(2442)); }; });
	},
	"./Footer": function() {
		return Promise.all([__webpack_require__.e(4920), __webpack_require__.e(4305), __webpack_require__.e(2846), __webpack_require__.e(6321)]).then(function() { return function() { return (__webpack_require__(6321)); }; });
	},
	"./ErrorPage": function() {
		return Promise.all([__webpack_require__.e(4920), __webpack_require__.e(4305), __webpack_require__.e(7567)]).then(function() { return function() { return (__webpack_require__(7567)); }; });
	},
	"./DataGridCellRenderers": function() {
		return Promise.all([__webpack_require__.e(4223), __webpack_require__.e(4948), __webpack_require__.e(6277), __webpack_require__.e(4920), __webpack_require__.e(8803), __webpack_require__.e(4305), __webpack_require__.e(5773), __webpack_require__.e(2846), __webpack_require__.e(4260)]).then(function() { return function() { return (__webpack_require__(4260)); }; });
	},
	"./SBOPTLogo": function() {
		return Promise.all([__webpack_require__.e(4920), __webpack_require__.e(4539)]).then(function() { return function() { return (__webpack_require__(9157)); }; });
	},
	"./GenericTable": function() {
		return Promise.all([__webpack_require__.e(4920), __webpack_require__.e(1572)]).then(function() { return function() { return (__webpack_require__(4994)); }; });
	},
	"./RecommendationRow": function() {
		return Promise.all([__webpack_require__.e(4920), __webpack_require__.e(4305), __webpack_require__.e(8087)]).then(function() { return function() { return (__webpack_require__(8087)); }; });
	},
	"./ModifyRecommendationsModal": function() {
		return Promise.all([__webpack_require__.e(4223), __webpack_require__.e(4948), __webpack_require__.e(4920), __webpack_require__.e(8803), __webpack_require__.e(4305), __webpack_require__.e(9875)]).then(function() { return function() { return (__webpack_require__(9875)); }; });
	},
	"./IdleConfirmationModal": function() {
		return Promise.all([__webpack_require__.e(4223), __webpack_require__.e(4948), __webpack_require__.e(4920), __webpack_require__.e(8803), __webpack_require__.e(4305), __webpack_require__.e(2594)]).then(function() { return function() { return (__webpack_require__(2594)); }; });
	},
	"./StyledComponents": function() {
		return Promise.all([__webpack_require__.e(4920), __webpack_require__.e(9158)]).then(function() { return function() { return (__webpack_require__(9158)); }; });
	},
	"./ErrorBoundary": function() {
		return Promise.all([__webpack_require__.e(4920), __webpack_require__.e(4305), __webpack_require__.e(2643)]).then(function() { return function() { return (__webpack_require__(2643)); }; });
	},
	"./DatePicker": function() {
		return __webpack_require__.e(386).then(function() { return function() { return (__webpack_require__(386)); }; });
	},
	"./BIReport": function() {
		return Promise.all([__webpack_require__.e(4920), __webpack_require__.e(8327), __webpack_require__.e(2181)]).then(function() { return function() { return (__webpack_require__(2181)); }; });
	},
	"./Dropdown": function() {
		return Promise.all([__webpack_require__.e(4920), __webpack_require__.e(7256)]).then(function() { return function() { return (__webpack_require__(7256)); }; });
	},
	"./Utils": function() {
		return __webpack_require__.e(341).then(function() { return function() { return (__webpack_require__(341)); }; });
	},
	"./Redirect": function() {
		return Promise.all([__webpack_require__.e(2846), __webpack_require__.e(2058)]).then(function() { return function() { return (__webpack_require__(2058)); }; });
	},
	"./CustomSnackBar": function() {
		return Promise.all([__webpack_require__.e(4920), __webpack_require__.e(3846)]).then(function() { return function() { return (__webpack_require__(3846)); }; });
	},
	"./ModalPopup": function() {
		return Promise.all([__webpack_require__.e(4223), __webpack_require__.e(4948), __webpack_require__.e(4920), __webpack_require__.e(8803), __webpack_require__.e(3487)]).then(function() { return function() { return (__webpack_require__(3487)); }; });
	}
};
var get = function(module, getScope) {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(function() {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = function(shareScope, initScope) {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: function() { return get; },
	init: function() { return init; }
});